import { render, staticRenderFns } from "./PackageQuotePosted.vue?vue&type=template&id=358984e7&"
import script from "./PackageQuotePosted.vue?vue&type=script&lang=js&"
export * from "./PackageQuotePosted.vue?vue&type=script&lang=js&"
import style0 from "./PackageQuotePosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageQuotePosted.vue"
export default component.exports